package com.heelion.farmafreelance.models

import kotlinx.serialization.Serializable

@Serializable
enum class UserRole {
    FARMACISTA,
    FARMACIA,
    INFERMIERE,
    ADMIN
}

/** Professionisti che lavorano a turno nelle farmacie (farmacisti e infermieri). */
val UserRole.isProfessionista: Boolean get() = this == UserRole.FARMACISTA || this == UserRole.INFERMIERE

/** La professione di questo ruolo; null per farmacia e admin. */
val UserRole.professione: Professione? get() = when (this) {
    UserRole.FARMACISTA -> Professione.FARMACISTA
    UserRole.INFERMIERE -> Professione.INFERMIERE
    else -> null
}

/** Come compare chi pubblica un annuncio con questo ruolo; null per l'admin. */
val UserRole.comeCreatore: CreatoreTipo? get() = when (this) {
    UserRole.FARMACIA -> CreatoreTipo.FARMACIA
    UserRole.FARMACISTA -> CreatoreTipo.FARMACISTA
    UserRole.INFERMIERE -> CreatoreTipo.INFERMIERE
    UserRole.ADMIN -> null
}

/** Il ruolo di chi lavora con questa professione. */
val Professione.ruolo: UserRole get() = when (this) {
    Professione.FARMACISTA -> UserRole.FARMACISTA
    Professione.INFERMIERE -> UserRole.INFERMIERE
}

/** "Farmacista" / "Infermiere", per le etichette. */
val Professione.etichetta: String get() = when (this) {
    Professione.FARMACISTA -> "Farmacista"
    Professione.INFERMIERE -> "Infermiere"
}
